import styled, { css } from 'styled-components'

export const Container = styled.div`
    width: 100%;
    line-height: 1.2;
`

export const Title = styled.div`
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    margin-bottom: 16px;
`

export const Wrapper = styled.div`
    width: 100%;
    background-color: white;
    padding: 16px;
    border-radius: 12px;
`

export const ListJob = styled.div<{ gridColumn?: number; gridMobileColumn?: number; isMobile?: boolean }>`
    ${({ gridColumn }) => css`
        display: flex;
        flex-wrap: wrap;
        gap: 16px;

        > div {
            width: calc((100% - 16px * ${(gridColumn || 1) - 1}) / ${gridColumn || 1});
        }
    `}

    ${({ gridMobileColumn }) =>
        gridMobileColumn &&
        css`
            @media (max-width: 768px) {
                > div {
                    width: calc((100% - 16px * ${(gridMobileColumn || 1) - 1}) / ${gridMobileColumn || 1});
                }
            }
        `}
`
